"use client";

import { SectionTitle } from "./sectionTitle";

export const Fee = () => {
	return (
		<div className="flex flex-col gap-4">
			<SectionTitle title="費用" />
			<div className="text-black font-bold font-zenMaru text-xl text-left">
				<p>無料</p>
				<p className="text-sm">
					※現地参加による旅費交通費や通信料は各自の負担となります。
				</p>
			</div>
		</div>
	);
};
